import React, { Children } from 'react'
import styled from 'styled-components'

export const ContentGridRoot = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	column-gap: ${p => p.columnGap}px;
	row-gap: ${p => p.rowGap}px;

	${p => p.theme.above('medium')`
		grid-template-columns: 1fr 1fr;
	`}

	${p => p.theme.above('large')`
		grid-template-columns: repeat(${p => p.cols ?? 2}, 1fr);
	`}
`

const GridItemRoot = styled.div`
	& > *:first-child {
		margin-top: 0px;
	}

	& > p:first-child {
		margin-top: 0px;
		padding-top: 0px;
	}

	${p =>
		p.stretch &&
		`
		& > *:first-child {
			height: 100%;
		}
	`}
`

export const GridItem = ({ children, stretch }) => <GridItemRoot stretch={stretch}>{children}</GridItemRoot>

const ContentGrid = ({ children, cols, stretch, columnGap = 32, rowGap = 32 }) => {
	return (
		<ContentGridRoot cols={cols} columnGap={columnGap} rowGap={rowGap}>
			{Children.map(children, ({ props }) => (
				<GridItem stretch={stretch} {...props} />
			))}
		</ContentGridRoot>
	)
}

export default ContentGrid
